/* eslint-disable */
const { ol, $ } = omjs;

let SmartOverlay = function (options) {
    ol.Overlay.call(this, options);

    this.overlay_padding = options.overlay_padding || 10;
    this.original_positioning = options.positioning;
    this.original_v_positioning = options.positioning.split('-')[0];
    this.original_h_positioning = options.positioning.split('-')[1];
    this.original_offset = options.offset !== undefined ? options.offset : [ 0, 0 ];
    this.flip_coord = null;
    this.safeSetOffset = _.throttle(this.safeSetOffset, 100);
};
ol.inherits(SmartOverlay, ol.Overlay);

enum OverlayPositioning {
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_CENTER = 'bottom-center',
    BOTTOM_RIGHT = 'bottom-right',
    CENTER_LEFT = 'center-left',
    CENTER_CENTER = 'center-center',
    CENTER_RIGHT = 'center-right',
    TOP_LEFT = 'top-left',
    TOP_CENTER = 'top-center',
    TOP_RIGHT = 'top-right',
}

SmartOverlay.prototype.getBoundingClientRect = function() {
    let mapElement: HTMLElement = this.getMap().getTargetElement();
    let mapBBox = mapElement.getBoundingClientRect();
    let {
        bottom,
        y,
        x,
        width,
        top,
        right,
        left,
        height
    }: DOMRect = this.getElement().getBoundingClientRect();

    return {
        y,
        x,
        width,
        height,
        top: top - mapBBox.top,
        right: right - mapBBox.right,
        bottom: bottom - mapBBox.bottom,
        left: left - mapBBox.left
    };
}

SmartOverlay.prototype.updateRenderedPosition = function(
    /* позиция [0,0] у тултипа в пикселях на карте */
    pixel: [number, number],
    /* ширина и высота карты */
    mapSize: [number, number]
) {
    // var style = this.element_.style
    var style = this.element.style
        , offset = this.getOffset()
        , positioning = this.getPositioning()
        , offsetX = offset[ 0 ]
        , offsetY = offset[ 1 ];

    let mapElement: HTMLElement = this.getMap().getTargetElement();
    let mapBBox = mapElement.getBoundingClientRect();
    let overlayBBox: DOMRect = this.getBoundingClientRect();


    const MIN_LEFT = 0;
    const MAX_LEFT = mapBBox.width - overlayBBox.width;

    const MIN_TOP = 0;
    const MAX_TOP = mapBBox.height - overlayBBox.height;

    const MIN_RIGHT = 0;
    const MAX_RIGHT = mapBBox.width - overlayBBox.width;

    const MIN_BOTTOM = 0;
    const MAX_BOTTOM = mapBBox.height - overlayBBox.height;
    if (
        positioning == OverlayPositioning.BOTTOM_RIGHT
        || positioning == OverlayPositioning.CENTER_RIGHT
        || positioning == OverlayPositioning.TOP_RIGHT
    ) {
        if(this.rendered.left_ !== '') {
            this.rendered.left_ = style.left = '';
        }
        var right = Math.round(mapSize[ 0 ] - pixel[ 0 ] - offsetX);
        if (right > MAX_RIGHT) {
            right = MAX_RIGHT;
        }
        if (right < MIN_RIGHT) {
            right = MIN_RIGHT;
        }

        if(this.rendered.right_ != right) {
            this.rendered.right_ = style.right = right + 'px';
        }
    } else {
        if(this.rendered.right_ !== '') {
            this.rendered.right_ = style.right = '';
        }
        if(positioning == OverlayPositioning.BOTTOM_CENTER ||
            positioning == OverlayPositioning.CENTER_CENTER ||
            positioning == OverlayPositioning.TOP_CENTER) {
            offsetX -= this.element.offsetWidth / 2;
        }
        var left = Math.round(pixel[ 0 ] + offsetX);
        if (left < MIN_LEFT) {
            left = MIN_LEFT;
        }
        if(left > MAX_LEFT) {
            left = MAX_LEFT;
        }
        if(this.rendered_left_ != left) {
            this.rendered.left_ = style.left = left + 'px';
        }
    }
    if(positioning == OverlayPositioning.BOTTOM_LEFT ||
        positioning == OverlayPositioning.BOTTOM_CENTER ||
        positioning == OverlayPositioning.BOTTOM_RIGHT) {
        if(this.rendered.top_ !== '') {
            this.rendered.top_ = style.top = '';
        }
        var bottom = Math.round(mapSize[ 1 ] - pixel[ 1 ] - offsetY);
        if (bottom > MAX_BOTTOM) {
            bottom = MAX_BOTTOM;
        }
        if (bottom < MIN_BOTTOM) {
            bottom = MIN_BOTTOM;
        }
        if(this.rendered.bottom_ != bottom) {
            this.rendered.bottom_ = style.bottom = bottom + 'px';
        }
    } else {
        if(this.rendered.bottom_ !== '') {
            this.rendered.bottom_ = style.bottom = '';
        }
        if(positioning == OverlayPositioning.CENTER_LEFT ||
            positioning == OverlayPositioning.CENTER_CENTER ||
            positioning == OverlayPositioning.CENTER_RIGHT) {
            offsetY -= this.element.offsetHeight / 2;
        }
        var top = Math.round(pixel[ 1 ] + offsetY);
        if (top < MIN_TOP) {
            top = MIN_TOP;
        }
        if (top > MAX_TOP) {
            top = MAX_TOP;
        }
        if(this.rendered.top_ != top) {
            this.rendered.top_ = style.top = top + 'px';
        }
    }
    this.setVisible(!0);
};

// SmartOverlay.prototype.updateRenderedPosition = function(
//     /* позиция [0,0] у тултипа в пикселях на карте */
//     pixel: [ number, number ],
//     /* ширина и высота карты */
//     mapSize: [ number, number ]
// ) {
//     ol.Overlay.prototype.updateRenderedPosition.apply(this, arguments);

//     if(this.BRUTEFORCE_LOCK) {
//         return;
//     }

//     let { style } = this.getElement();
//     let map_width = mapSize[0];

//     style.visibility = 'hidden';

//     let { left_, right_ } = this.rendered_;

//     left_ = parseFloat(left_);
//     right_ = parseFloat(right_);

//     let overlayBBox: DOMRect = this.getBoundingClientRect();
//     let offset = this.getOffset();
//     let [ orig_h_offset, orig_v_offset ] = this.original_offset;
//     let el_width = overlayBBox.width;

//     if(el_width > map_width) {
//         return;
//     }

//     this.BRUTEFORCE_LOCK = true;

//     if(DomRectUtils.isOutLeft(overlayBBox)) {
//         let h_offset = offset[ 0 ] + Math.abs(overlayBBox.left);
//         if(h_offset <= orig_h_offset) {
//             h_offset = orig_h_offset;
//         }
//         this.setOffset([ h_offset, offset[ 1 ] ]);
//     }

//     if(DomRectUtils.isOutRight(overlayBBox)) {
//         let h_offset = offset[ 0 ] - Math.abs(overlayBBox.right);
//         if(h_offset >= orig_h_offset) {
//             h_offset = orig_h_offset;
//         }
//         this.setOffset([ h_offset, offset[ 1 ] ]);
//     }

//     if(DomRectUtils.isOutTop(overlayBBox)) {
//         let v_offset = offset[ 1 ] + Math.abs(overlayBBox.top);
//         if(v_offset <= orig_v_offset) {
//             v_offset = orig_v_offset;
//         }
//         this.setOffset([ offset[ 0 ], v_offset ]);
//     }

//     if(DomRectUtils.isOutBottom(overlayBBox)) {
//         let v_offset = offset[ 1 ] - Math.abs(overlayBBox.bottom);
//         if(v_offset >= orig_v_offset) {
//             v_offset = orig_v_offset;
//         }
//         this.setOffset([ offset[ 0 ], v_offset ]);
//     }

//     this.BRUTEFORCE_LOCK = false;

//     // if (!this.tryResetPosition()) {
//     //     if(DomRectUtils.isHorizontalOutside(overlayBBox)) {
//     //         this.bruteForceHorizontalPosition();
//     //     }

//     //     if(DomRectUtils.isVerticalOutside(overlayBBox)) {
//     //         this.bruteForceVerticalPosition();
//     //     }
//     // }



//     style.visibility = '';
// }

// SmartOverlay.prototype.forEachHorizontalPosition = function(position: string, callback: (position: string) => boolean) {
//     let cwPos = [ 'left', 'center', 'right' ];
//     let posIndex = cwPos.indexOf(position);
//     for (let nextPositionIndex = posIndex + 1, i = 0; i < cwPos.length; i++) {
//         let pos = cwPos[nextPositionIndex];
//         if (!pos) {
//             nextPositionIndex = 0;
//             pos = cwPos[nextPositionIndex];
//         }
//         let doBreak = callback(pos);
//         if (doBreak) {
//             break;
//         }
//         nextPositionIndex++;
//     }
// }

// SmartOverlay.prototype.forEachVerticalPosition = function (position: string, callback: (position: string) => boolean) {
//     let cwPos = [ 'top', 'bottom' ];
//     let posIndex = cwPos.indexOf(position);
//     for(let nextPositionIndex = posIndex + 1, i = 0; i < cwPos.length; i++) {
//         let pos = cwPos[ nextPositionIndex ];
//         if(!pos) {
//             nextPositionIndex = 0;
//             pos = cwPos[ nextPositionIndex ];
//         }
//         let doBreak = callback(pos);
//         if(doBreak) {
//             break;
//         }
//         nextPositionIndex++;
//     }
// }

// SmartOverlay.prototype.bruteForceHorizontalPosition = function() {
//     this.BRUTEFORCE_LOCK = true;
//     let positioning = this.getPositioning();
//     let positioning_array: [string, string] = positioning.split('-');

//     this.forEachHorizontalPosition(positioning_array[1], (nextPosition: string) => {
//         this.setPositioning(`${ positioning_array[ 0 ] }-${ nextPosition }`);
//         let newRect = this.getBoundingClientRect();
//         if(!DomRectUtils.isHorizontalOutside(newRect)) {
//             this.BRUTEFORCE_LOCK = false;
//             return true;
//         }
//     });

//     this.BRUTEFORCE_LOCK = false;
// }

// SmartOverlay.prototype.bruteForceVerticalPosition = function() {
//     this.BRUTEFORCE_LOCK = true;
//     let positioning = this.getPositioning();
//     let positioning_array: [ string, string ] = positioning.split('-');

//     this.forEachVerticalPosition(positioning_array[0], (nextPosition: string) => {
//         if (nextPosition === 'bottom') {
//             let offset = this.getOffset();
//             this.setOffset([ offset[ 0 ], -offset[1] ])
//         } else {
//             this.setOffset(this.original_offset);
//         }
//         this.setPositioning(`${nextPosition}-${positioning_array[1]}`);
//         let newRect = this.getBoundingClientRect();
//         if(!DomRectUtils.isVerticalOutside(newRect)) {
//             this.BRUTEFORCE_LOCK = false;
//             return true;
//         }
//     });

//     this.BRUTEFORCE_LOCK = false;
// }

// SmartOverlay.prototype.tryResetPosition = function () {
//     this.BRUTEFORCE_LOCK = true;
//     let positioning = this.getPositioning();
//     this.setPositioning(this.original_positioning);
//     let newRect = this.getBoundingClientRect();

//     if (DomRectUtils.isInside(newRect)) {
//         this.BRUTEFORCE_LOCK = false;
//         return true;
//     } else {
//         debugger;
//         this.setPositioning(positioning);
//         this.BRUTEFORCE_LOCK = false;
//         return false;
//     }
// }

// SmartOverlay.prototype.getOppositePosition = function(position) {
//     switch (position) {
//         case 'bottom':
//             return 'top';
//         case 'top':
//             return 'bottom';
//         case 'left':
//             return 'right';
//         case 'right':
//             return 'left';
//         case 'center':
//             return 'center';
//         default:
//             return '';
//     }
// };

// SmartOverlay.prototype.safeSetOffset = function(offset) {
//     let old_offset_x = this.getOffset()[0];
//     let old_offset_y = this.getOffset()[1];

//     let new_offset_x = offset[0];
//     let new_offset_y = offset[1];

//     if (
//         (old_offset_x !== new_offset_x)
//         || (old_offset_y !== new_offset_y)
//     ) {
//         this.setOffset(offset);
//         return true;
//     } else {
//         return false;
//     }
// };

// SmartOverlay.prototype.setContent = function(content) {
//     this.$inner_el.html(content);
// };


// abstract class DomRectUtils {
//     static isOutTop(box: DOMRect) {
//         return box.top < 0;
//     }

//     static isOutBottom(box: DOMRect) {
//         return box.bottom > 0;
//     }

//     static isOutLeft(box: DOMRect) {
//         return box.left < 0;
//     }

//     static isOutRight(box: DOMRect) {
//         return box.right > 0;
//     }

//     static isVerticalOutside(box: DOMRect) {
//         return (
//             DomRectUtils.isOutTop(box)
//             || DomRectUtils.isOutBottom(box)
//         );
//     }

//     static isHorizontalOutside(box: DOMRect) {
//         return (
//             DomRectUtils.isOutLeft(box)
//             || DomRectUtils.isOutRight(box)
//         );
//     }

//     static isInside(box: DOMRect) {
//         return (
//             !DomRectUtils.isVerticalOutside(box)
//             && !DomRectUtils.isHorizontalOutside(box)
//         );
//     }
// }

export default SmartOverlay;
